/**
 * Query keys for payment methods
 * Aligns with backend PaymentMethodsController methods
 */
export const paymentMethodsKeys = {
  setupIntent: () => ["payment-methods", "createSetupIntent"] as const,
  findAll: () => ["payment-methods", "findAll"] as const,
  remove: (uuid: string) => ["payment-methods", "remove", uuid] as const,
  setAsDefault: (uuid: string) =>
    ["payment-methods", "setAsDefault", uuid] as const,
  syncFromStripe: () => ["payment-methods", "syncFromStripe"] as const,
} as const
